import { Component, EventEmitter, Input, Output } from "@angular/core";

export interface DownloadClickEvent {
  reportType: string;
}

@Component({
  selector: "download-button",
  templateUrl: "download-button.component.html",
})
export class DownloadButtonComponent {
  @Input()
  reportType: string = "default";

  @Output()
  downloadClick = new EventEmitter<DownloadClickEvent>();

  private buttonText: string = "Download";

  onDownloadClick(): void {
    this.downloadClick.emit({ reportType: this.reportType });
  }
}



// WEBPACK FOOTER //
// ./src/components/download-button/download-button.component.ts